import { useState } from 'react';
import { Placeholder, Spinner } from '@telegram-apps/telegram-ui';
import { Villa } from '../types';
import VillaCard from './VillaCard';
import EditDrawer from './EditDrawer';
import StatusPicker from './StatusPicker';

interface ArchiveViewProps {
  villas: Villa[];
  loading: boolean;
  onRefresh: () => void;
  onChange: (villa: Villa) => void;
  onRestore: (id: string) => void;
}

export default function ArchiveView({
  villas,
  loading,
  onRefresh,
  onChange,
  onRestore,
}: ArchiveViewProps) {
  const [editingVilla, setEditingVilla] = useState<Villa | null>(null);
  const [statusPickerVilla, setStatusPickerVilla] = useState<Villa | null>(null);

  const handleStatusChange = (villa: Villa, newStatus: string) => {
    const updated = { ...villa, status: newStatus as Villa['status'] };
    onChange(updated);
    setStatusPickerVilla(null);
  };

  if (loading) {
    return (
      <Placeholder>
        <Spinner size="l" />
        Загрузка...
      </Placeholder>
    );
  }

  if (villas.length === 0) {
    return (
      <Placeholder
        header="Архив пуст"
        description="Здесь будут архивные виллы"
      />
    );
  }

  return (
    <>
      <div className="villa-view">
        <h2>Архив ({villas.length})</h2>
        <div className="villa-list villa-list--list">
          {villas.map(villa => (
            <VillaCard
              key={villa.id}
              villa={villa}
              viewMode="list"
              onStatusClick={(v) => setStatusPickerVilla(v)}
              onEdit={setEditingVilla}
              isArchived
            />
          ))}
        </div>
      </div>

      {statusPickerVilla && (
        <StatusPicker
          villa={statusPickerVilla}
          open={true}
          onClose={() => setStatusPickerVilla(null)}
          onChange={(newStatus) => handleStatusChange(statusPickerVilla, newStatus)}
        />
      )}

      {editingVilla && (
        <EditDrawer
          villa={editingVilla}
          open={true}
          onClose={() => setEditingVilla(null)}
          onChange={onChange}
          onMoveToArchive={() => {}}
          isArchived
        />
      )}
    </>
  );
}
